import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ButtonEventService {

  /*для кнопки добавить квартиру*/
  private buttonClickSubject = new Subject<boolean>();
  buttonClick$ = this.buttonClickSubject.asObservable();


  private updateBuildingSubject = new Subject<boolean>();
  buildingUpdated$ = this.updateBuildingSubject.asObservable();

  emitButtonClick(bool: boolean) {
    this.buttonClickSubject.next(bool);
  }

  updateBuilding() {
    this.updateBuildingSubject.next(true);
  }

}
